import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { toHttpParams } from '../http/http-params';
import { NotificationPage } from '../models/notification.models';

/** In-app notifications (/api/notifications): the bell count, the list, and marking one as read. */
@Injectable({ providedIn: 'root' })
export class NotificationsService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiBaseUrl}/notifications`;

  unreadCount(): Observable<number> {
    return this.http
      .get<{ unreadCount: number }>(`${this.url}/unread-count`)
      .pipe(map((response) => response.unreadCount));
  }

  list(pageNumber = 1, pageSize = 20, unreadOnly = false): Observable<NotificationPage> {
    return this.http.get<NotificationPage>(this.url, {
      params: toHttpParams({ pageNumber, pageSize, unreadOnly }),
    });
  }

  markRead(id: string): Observable<void> {
    return this.http.post<void>(`${this.url}/${id}/read`, {});
  }
}
